import React from "react";
import { createRoot } from "react-dom/client";
import "@/ui/tokens.css";
import { App } from "@/app/App";
import { registerWorkerEngineFactory, hostMode } from "@/engine/transport";
import { createMockEngine } from "@/engine/mock-transport";
import { toast } from "@/ui";

// Decided once at load, before any redirect strips the query string; remembered for the tab so reloads keep it.
const wantsMock = (() => {
  const search = new URLSearchParams(window.location.search);
  const hashQuery = window.location.hash.split("?")[1];
  const fromUrl = search.get("engine") ?? (hashQuery ? new URLSearchParams(hashQuery).get("engine") : null);
  try {
    if (fromUrl === "mock") sessionStorage.setItem("hub_engine", "mock");
    else if (fromUrl) sessionStorage.removeItem("hub_engine");
    return sessionStorage.getItem("hub_engine") === "mock";
  } catch {
    return fromUrl === "mock";
  }
})();

registerWorkerEngineFactory(async () => {
  if (wantsMock) {
    const mock = createMockEngine();
    if (import.meta.env.DEV) (window as unknown as { __hubEngine?: unknown }).__hubEngine = mock;
    return mock;
  }
  try {
    const { createWorkerTransport } = await import("@/engine/worker-transport");
    const transport = await createWorkerTransport();
    // Development aid: lets you call the engine from the browser console (window.__hubEngine.invoke(method, params)).
    if (import.meta.env.DEV) (window as unknown as { __hubEngine?: unknown }).__hubEngine = transport;
    return transport;
  } catch (e) {
    console.warn("[hub] local engine unavailable, using demo data:", e);
    setTimeout(() => toast("The local engine is unavailable, showing demo data"), 500);
    return createMockEngine();
  }
});

document.documentElement.setAttribute("data-mode", hostMode());

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
